import EmptyState from '@atlaskit/empty-state';
import { useFlags } from '@atlaskit/flag';
import { SpinnerMask } from '@atlassian/amkt-common';
import { updatePartnerPaymentDetails } from '@atlassian/mpac-api-client';
import { showModalIfTwoSVSessionExpires, useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import React from 'react';
import { getFlagForError, getFlagForSuccess } from '../../../utils';
import { TabHeader } from '../../common/components/Tabs';
import { usePartnerPaymentDetails } from './hooks';
import { getUpdatePaymentDetailsPayload } from './PartnerPaymentInfo.utils';
import PaymentInfoForm from './PaymentInfoForm';
import GenericErrorImage from '../../common/components/images/generic-error.svg';
const PartnerPaymentInfo = _ref => {
  let {
    mpacBaseUrl,
    partnerId,
    permissions
  } = _ref;
  const {
    paymentDetails,
    isPaymentDetailsRejected,
    isPaymentDetailsPending,
    paymentDetailsError,
    cancelPendingPaymentDetails,
    reloadPaymentDetails
  } = usePartnerPaymentDetails(mpacBaseUrl, partnerId);
  const {
    showFlag
  } = useFlags();
  const {
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  const handleSubmit = async fields => {
    try {
      await updatePartnerPaymentDetails(mpacBaseUrl, partnerId, getUpdatePaymentDetailsPayload(fields, paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails._links));
      showFlag(getFlagForSuccess('partner-admin-details-patch-success', 'You’ve successfully saved payment details'));
      cancelPendingPaymentDetails();
      reloadPaymentDetails();
    } catch (error) {
      showModalIfTwoSVSessionExpires(error, setTwoStepAuthTimedOut);
      showFlag(getFlagForError('partner-admin-details-patch-failure', 'Unable to save payment details'));
    }
  };
  if (isPaymentDetailsRejected) {
    /* There won’t be any payment plan for the first time (or a new partner) in which the backend returns 404.
     *  We need handle this case and render the empty form info in case of 404
     */
    if ((paymentDetailsError === null || paymentDetailsError === void 0 ? void 0 : paymentDetailsError.status) === 404) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
        headerText: "Payment information"
      }), /*#__PURE__*/React.createElement(SpinnerMask, {
        active: isPaymentDetailsPending,
        size: 50
      }, /*#__PURE__*/React.createElement(PaymentInfoForm, {
        handleSubmit: handleSubmit,
        isReadOnly: !permissions.canManagePartnerPaymentDetails
      })));
    }
    return /*#__PURE__*/React.createElement(EmptyState, {
      header: "We ran into a little trouble",
      description: "It might just be a hiccup. Try again in a bit.",
      imageUrl: GenericErrorImage
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Payment information"
  }), /*#__PURE__*/React.createElement(SpinnerMask, {
    active: isPaymentDetailsPending,
    size: 50
  }, paymentDetails && /*#__PURE__*/React.createElement(PaymentInfoForm, {
    paymentDetails: paymentDetails,
    handleSubmit: handleSubmit,
    isReadOnly: !permissions.canManagePartnerPaymentDetails
  })));
};
export default PartnerPaymentInfo;